import units from "utils/units"
import { BaseComponent } from "utils/base-component"
import { SearchSection, SearchItem } from "./data"
import css from "./style.module.scss"

type Config = {
  item: SearchItem
  section: SearchSection
  onChoose: (item: SearchItem) => void
}

export class Item extends BaseComponent<Config> {
  static cssClass = css.item
  static tagName = "li"

  private link!: HTMLAnchorElement
  private title!: HTMLElement
  private dist!: HTMLElement

  init() {
    const { item } = this.config

    this.root.id = `active-descendant-${item.id}`
    this.root.setAttribute("role", "option")
    this.root.setAttribute("aria-selected", "false")
    this.root.classList.add(css[this.config.section.kind])

    this.link = document.createElement("a")
    this.link.classList.add(css.link)
    item.itemCss().forEach((c: string) => this.link.classList.add(css[c]))
    this.link.href = "#"

    this.root.addEventListener("click", (e) => {
      e.preventDefault()
      this.config.onChoose(item)
    })
    this.root.appendChild(this.link)

    const icon = document.createElement("div")
    icon.classList.add(css.icon)
    item.iconCss().forEach((c: string) => icon.classList.add(css[c]))
    this.link.appendChild(icon)

    const content = document.createElement("div")
    content.classList.add(css.content)
    this.link.appendChild(content)

    this.title = document.createElement("div")
    this.title.classList.add(css.title)
    this.title.textContent = item.name
    if (item.englishName && item.englishName !== item.name) {
      const englishName = document.createElement("span")
      englishName.classList.add(css.englishName)
      englishName.textContent = ` (${item.englishName})`
      this.title.appendChild(englishName)
    }
    content.appendChild(this.title)

    const subtitleText = item.subtitle(this.config.section)
    if (subtitleText) {
      const subtitle = document.createElement("div")
      subtitle.classList.add(css.subtitle)

      const iconCss = item.subtitleIconCss(this.config.section)
      if (iconCss) {
        const subicon = document.createElement("div")
        subicon.classList.add(css.subtitleIcon)
        iconCss.forEach((c: string) => subicon.classList.add(css[c]))
        subtitle.appendChild(subicon)
      }

      subtitle.appendChild(document.createTextNode(subtitleText))

      content.appendChild(subtitle)
    }

    if (item.dist) {
      this.dist = document.createElement("div")
      this.dist.classList.add(css.dist)
      this.renderDist()
      this.link.appendChild(this.dist)
      units.onChange(() => this.renderDist())
    }
  }

  renderDist() {
    const dist = this.config.item.dist!
    const precision = dist > 0.05 && dist < 1 ? 0.1 : 1
    this.dist.innerText = units.formatDist(dist, { withUnits: true, precision })
  }

  setSelected(selected: boolean) {
    this.root!.setAttribute("aria-selected", String(selected))
    this.link.classList.toggle(css.selected, selected)
  }

  // // TODO: pass highlight from the backend to handle accutes etc?
  // setQuery(query: string) {
  //   const { location } = this.config
  //   this.locationName.innerHTML = location.name.replace(
  //     new RegExp(query, 'i'),
  //     (substring: string) =>
  //       `<span class="${css['location-autocomplete-query']}">${substring}</span>`
  //   )
  // }
}
